import { useStore } from '@modules';
import { CurrencyEnum } from '@modules/global/types';

export type TUseTotalDigits = {
  getTotalDigits: (cur: CurrencyEnum) => number;
  getDisplayDigits: (cur: CurrencyEnum) => number;
};

export const useTotalDigits = (): TUseTotalDigits => {
  const [{ global }] = useStore();
  const { currencies } = global;
  const currenciesDisplayOptions = currencies.config.display_options || null;

  const getTotalDigits = (cur: CurrencyEnum) => currenciesDisplayOptions[cur]?.total_digits || 0;
  const getDisplayDigits = (cur: CurrencyEnum) =>
    currenciesDisplayOptions[cur]?.display_digits || 0;

  return { getTotalDigits, getDisplayDigits };
};

export default useTotalDigits;
